// utils/whatsappLogHelper/logs.ts - utils/whatsappLogHelper.ts split (sub-module logs)

import { supabase } from '../../supabase/client';


/**
 * Get WhatsApp logs for a specific order
 */
export async function getWhatsAppLogs(orderId: string) {
    try {
        const { data, error } = await supabase
            .from('whatsapp_logs')
            .select('*')
            .eq('order_id', orderId)
            .order('created_at', { ascending: false });

        if (error) {
            console.error('[WhatsApp Log] Fetch error:', error);
            return [];
        }

        return data || [];
    } catch (err) {
        console.error('[WhatsApp Log] Fetch exception:', err);
        return [];
    }
}



/**
 * Update WhatsApp log retry count and status
 */
export async function updateWhatsAppLogRetry(logId: string, retryCount: number, success: boolean = false) {
    try {
        const updateData: any = {
            retry_count: retryCount,
            last_retry_at: new Date().toISOString(),
        };

        // If retry was successful, update status to 'sent'
        if (success) {
            updateData.status = 'sent';
            updateData.error_message = null;
        }

        const { error } = await supabase
            .from('whatsapp_logs')
            .update(updateData)
            .eq('id', logId);

        if (error) {
            console.error('[WhatsApp Log] Update error:', error);
            return false;
        }

        return true;
    } catch (err) {
        console.error('[WhatsApp Log] Update exception:', err);
        return false;
    }
}



/**
 * Get WhatsApp statistics for order
 */
export async function getWhatsAppLogStats(orderId: string) {
    try {
        const { data, error } = await supabase
            .from('whatsapp_logs')
            .select('status')
            .eq('order_id', orderId);

        if (error) return { sent: 0, failed: 0, pending: 0, total: 0 };

        const stats = {
            sent: data?.filter(d => d.status === 'sent').length || 0,
            failed: data?.filter(d => d.status === 'failed').length || 0,
            pending: data?.filter(d => d.status === 'pending').length || 0,
            total: data?.length || 0,
        };

        return stats;
    } catch (err) {
        console.error('[WhatsApp Log] Stats error:', err);
        return { sent: 0, failed: 0, pending: 0, total: 0 };
    }
}
